(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.section-header');
    if (!header) return;

    const root = document.documentElement;
    let lastScrollTop = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
    const hideStartOffset = 80;
    const minDelta = 3;

    const updateHeaderHeight = () => {
      const h = Math.round(header.getBoundingClientRect().height);
      if (h > 0) root.style.setProperty('--header-height', `${h}px`);
    };

    const onScroll = () => {
      const scrollTop = Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
      const delta = scrollTop - lastScrollTop;

      if (scrollTop <= 0) {
        header.classList.remove('bs-header-hidden');
        lastScrollTop = scrollTop;
        return;
      }

      if (Math.abs(delta) < minDelta) return;

      if (delta > 0 && scrollTop > hideStartOffset) {
        header.classList.add('bs-header-hidden');
      } else if (delta < 0) {
        header.classList.remove('bs-header-hidden');
      }

      lastScrollTop = scrollTop;
    };

    const onResize = () => {
      updateHeaderHeight();
    };

    if (typeof ResizeObserver !== 'undefined') {
      const headerObserver = new ResizeObserver(updateHeaderHeight);
      headerObserver.observe(header);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    updateHeaderHeight();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-gradient"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__buddysoftHeroCarouselInit) return;
  window.__buddysoftHeroCarouselInit = true;

  const registry = new WeakMap();

  class BuddysoftHeroCarousel {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('.buddysoft-hero-carousel__viewport');
      this.track = root.querySelector('[data-carousel-track]');
      this.dots = root.querySelectorAll('[data-carousel-dot]');

      if (!this.viewport || !this.track) return;

      this.speed = (parseFloat(root.dataset.speed) || 4) * 1000;
      this.transitionMs = 800;
      this.autoplayEnabled = root.dataset.autoplay !== 'false';
      this.timer = null;
      this.loopResetTimer = null;
      this.isAnimating = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.setupSlides();
      if (this.realSlideCount < 2) return;

      this.currentIndex = 0;

      this._onResize = () => this.syncLayout();
      this._onTransitionEnd = (event) => this.handleTransitionEnd(event);
      window.addEventListener('resize', this._onResize);
      this.track.addEventListener('transitionend', this._onTransitionEnd);

      this._onMouseEnter = () => this.stopAutoplay();
      this._onMouseLeave = () => this.startAutoplay();
      this.root.addEventListener('mouseenter', this._onMouseEnter);
      this.root.addEventListener('mouseleave', this._onMouseLeave);

      this.syncLayout();
      this.setTransition(!this.reducedMotion);
      this.applyTransform();
      this.updateSlideStates();

      if (this.autoplayEnabled && !this.reducedMotion) {
        this.startAutoplay();
      }

      root.setAttribute('data-carousel-initialized', 'true');
    }

    setupSlides() {
      this.track.querySelectorAll('[data-carousel-slide-clone][data-js-clone]').forEach((slide) => slide.remove());

      this.realSlides = this.track.querySelectorAll('[data-carousel-slide]');
      this.realSlideCount = this.realSlides.length;
      this.cloneSlide = this.track.querySelector('[data-carousel-slide-clone]');

      if (this.realSlideCount < 2) return;

      if (!this.cloneSlide && !this.reducedMotion) {
        const clone = this.realSlides[0].cloneNode(true);
        clone.setAttribute('data-carousel-slide-clone', '');
        clone.setAttribute('data-js-clone', '');
        clone.removeAttribute('data-carousel-slide');
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.remove('is-active');

        const heading = clone.querySelector('h1');
        if (heading) {
          const replacement = document.createElement('p');
          replacement.className = heading.className;
          replacement.innerHTML = heading.innerHTML;
          heading.replaceWith(replacement);
        }

        clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });

        this.track.appendChild(clone);
        this.cloneSlide = clone;
      }

      this.slides = this.track.querySelectorAll('[data-carousel-slide], [data-carousel-slide-clone]');
    }

    destroy() {
      this.stopAutoplay();
      this.clearLoopResetTimer();
      window.removeEventListener('resize', this._onResize);
      this.track.removeEventListener('transitionend', this._onTransitionEnd);
      this.root.removeEventListener('mouseenter', this._onMouseEnter);
      this.root.removeEventListener('mouseleave', this._onMouseLeave);
      this.track.querySelectorAll('[data-carousel-slide-clone][data-js-clone]').forEach((slide) => slide.remove());
      this.root.removeAttribute('data-carousel-initialized');
    }

    clearLoopResetTimer() {
      if (this.loopResetTimer) {
        window.clearTimeout(this.loopResetTimer);
        this.loopResetTimer = null;
      }
    }

    getSlideWidth() {
      return this.viewport.clientWidth;
    }

    getLogicalIndex() {
      if (this.currentIndex >= this.realSlideCount) return 0;
      return this.currentIndex;
    }

    syncLayout() {
      const slideWidth = this.getSlideWidth();
      if (slideWidth <= 0) {
        window.requestAnimationFrame(() => this.syncLayout());
        return;
      }

      this.root.style.setProperty('--hero-carousel-slide-width', `${slideWidth}px`);

      const tallest = Math.max(...Array.from(this.slides).map((slide) => slide.offsetHeight));
      if (tallest > 0) {
        this.viewport.style.minHeight = `${tallest}px`;
      }

      this.applyTransform();
    }

    setTransition(enabled) {
      this.track.style.transition = enabled ? `transform ${this.transitionMs}ms ease-in-out` : 'none';
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.reducedMotion || this.realSlideCount < 2) return;
      this.stopAutoplay();
      this.timer = window.setInterval(() => this.next(), this.speed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      if (this.isAnimating || this.realSlideCount < 2) return;

      if (this.reducedMotion) {
        this.currentIndex = (this.currentIndex + 1) % this.realSlideCount;
        this.applyTransform();
        this.updateSlideStates();
        return;
      }

      if (this.currentIndex >= this.realSlideCount) return;

      const nextIndex = this.currentIndex + 1;
      this.setTransition(true);

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          this.currentIndex = nextIndex;
          this.applyTransform();
          this.updateSlideStates();

          if (nextIndex === this.realSlideCount) {
            this.isAnimating = true;
            this.scheduleLoopReset();
          }
        });
      });
    }

    scheduleLoopReset() {
      this.clearLoopResetTimer();
      this.loopResetTimer = window.setTimeout(() => {
        if (this.currentIndex === this.realSlideCount) {
          this.resetToStart();
        }
      }, this.transitionMs + 120);
    }

    handleTransitionEnd(event) {
      if (event.target !== this.track || event.propertyName !== 'transform') return;
      if (this.currentIndex !== this.realSlideCount) return;
      this.resetToStart();
    }

    resetToStart() {
      if (this.currentIndex !== this.realSlideCount) return;

      this.clearLoopResetTimer();
      this.setTransition(false);
      this.currentIndex = 0;
      this.applyTransform();
      this.updateSlideStates();

      void this.track.offsetHeight;

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          this.setTransition(!this.reducedMotion);
          this.isAnimating = false;
        });
      });
    }

    applyTransform() {
      const offset = this.currentIndex * this.getSlideWidth();
      this.track.style.transform = `translate3d(-${offset}px, 0, 0)`;
    }

    updateSlideStates() {
      const logicalIndex = this.getLogicalIndex();

      this.slides.forEach((slide, index) => {
        const isActive = index === this.currentIndex;
        slide.toggleAttribute('aria-hidden', !isActive);
        slide.classList.toggle('is-active', isActive);

        slide.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
          if (isActive && !slide.hasAttribute('data-carousel-slide-clone')) {
            element.removeAttribute('tabindex');
          } else {
            element.setAttribute('tabindex', '-1');
          }
        });
      });

      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === logicalIndex);
      });
    }
  }

  function initBuddysoftHeroCarousels(scope = document) {
    const roots = scope.querySelectorAll
      ? scope.querySelectorAll('.buddysoft-hero-carousel[data-autoplay]')
      : [];

    roots.forEach((root) => {
      const existing = registry.get(root);
      if (existing) {
        existing.destroy();
        registry.delete(root);
      }

      const carousel = new BuddysoftHeroCarousel(root);
      if (carousel.track && carousel.realSlideCount >= 2) {
        registry.set(root, carousel);
      }
    });
  }

  window.initBuddysoftHeroCarousels = initBuddysoftHeroCarousels;

  const boot = () => initBuddysoftHeroCarousels(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) {
      initBuddysoftHeroCarousels(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target) return;
    event.target.querySelectorAll('.buddysoft-hero-carousel[data-autoplay]').forEach((root) => {
      const existing = registry.get(root);
      if (existing) {
        existing.destroy();
        registry.delete(root);
      }
    });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
